import { ContentCopy, Delete, FileUpload, Upgrade } from '@mui/icons-material'
import { preview } from '@/components/form/preview'
import { useResidentModalsApi } from '@/components/modals/ResidentModals'
import { useSingleViewData } from '../../../hooks/useSingleViewData'
import type { SingleViewActionsProps } from '../../../typings'
import { useTexts } from './useTexts'

export function PreviewActions(props: SingleViewActionsProps) {
  const { tab } = props
  const texts = useTexts()

  const {
    exportOrders: { show: showExportOrderModal },
    deleteOrders: { show: handleDeleteOrders },
    duplicateOrders: { show: handleDuplicateOrders },
    copySelectedOrders: { show: handleCopySelectedOrders },
  } = useResidentModalsApi()

  const {
    order,
    isSimulation,
    canAddNewOrder,
    orderInArchivedDay,
    isExecutionEventsTab,
    canExportExecutionOrder,
    duplicateDisabledTooltipTitle,
    date,
  } = useSingleViewData(props)

  if (!order) return null

  const canDuplicate = canAddNewOrder && !orderInArchivedDay
  const canDelete = !orderInArchivedDay
  const canExport = tab === 0 || tab === 1
  const isExportDisabled = isExecutionEventsTab && !canExportExecutionOrder

  return (
    <preview.ActionBar testId="orderPreviewModal-actions">
      {isSimulation ? (
        <preview.ActionBarItem
          key="copy-to-operations"
          icon={<Upgrade />}
          label={texts.copyToOperations}
          onClick={() => handleCopySelectedOrders([order.id])}
          tooltip={canAddNewOrder ? texts.copyToOperations : duplicateDisabledTooltipTitle}
          disabled={!canAddNewOrder}
          data-testid="orderPreviewModal__copy_to_operations"
          data-trackid="orderPreviewModal__copy_to_operations"
          disableWhenReadOnly
        />
      ) : (
        <></>
      )}

      <preview.ActionBarItem
        key="duplicate"
        icon={<ContentCopy />}
        label={texts.duplicate}
        onClick={() => handleDuplicateOrders([order.id])}
        tooltip={
          !canDuplicate
            ? orderInArchivedDay
              ? texts.duplicateDisabledArchived
              : duplicateDisabledTooltipTitle
            : texts.duplicate
        }
        disabled={!canDuplicate}
        data-testid="orderPreviewModal__duplicate"
        data-trackid="orderPreviewModal__duplicate"
        disableWhenReadOnly
      />

      {canExport ? (
        <preview.ActionBarItem
          key="export"
          icon={<FileUpload />}
          label={texts.export}
          onClick={() =>
            showExportOrderModal(
              tab === 0 ? 'configuration' : 'execution',
              [order.id],
              [order],
              date,
              isSimulation ? 'simulation' : orderInArchivedDay ? 'archived' : 'operations',
            )
          }
          tooltip={texts.export}
          disabled={isExportDisabled}
          data-testid="orderPreviewModal__export"
          data-trackid="orderPreviewModal__export"
          disableWhenReadOnly={false}
        />
      ) : (
        <></>
      )}

      <preview.ActionBarItem
        key="delete"
        icon={<Delete />}
        label={texts.delete}
        onClick={() => handleDeleteOrders([order.id])}
        tooltip={!canDelete ? texts.deleteDisabledArchived : texts.delete}
        disabled={!canDelete}
        data-testid="orderPreviewModal__delete"
        data-trackid="orderPreviewModal__delete"
        disableWhenReadOnly
      />
    </preview.ActionBar>
  )
}
